(function(){
	if(typeof APPS === 'undefined'){ APPS = {}; }
	APPS.pledge = {};
	/*================================================================================
		Router
	 ================================================================================*/
	var Router = Marionette.AppRouter.extend({
		appRoutes:{
			 ""  : "showFullPledge"
			,"pledge"  : "showFullPledge"
		}
	})
	
	/*================================================================================
		Api - called by the Router and through Radio events
	 ================================================================================*/
	var API = {
		 showFullPledge:function(){
			APPS.pledge.fullpledge.show();
		}
		,showThankYouFull:function(data){
			APPS.pledge.thankyoufull.show(data);
		}
		,updatePaymentMethod:function(pledgeData){
			APPS.pledge.updatePaymentMethod.show(pledgeData);
		}
	}
	
	/*================================================================================
		Radio - Event Handlers
	 ================================================================================*/
	Backbone.Radio.channel('pledge').reply("thankyoufull",function(data){
		Backbone.history.navigate('/thanks')
		API.showThankYouFull(data);
	});
	
	Backbone.Radio.channel('pledge').reply("updatePaymentMethod",function(pledgeData){
		API.updatePaymentMethod(pledgeData);
	});
	

		
	
	APP.on("before:start",function(){
		new Router({
			controller: API
		})
	})
})()